import React from 'react';
import WebApp from '@twa-dev/sdk';
import { PhoneOutlined, EnvironmentOutlined } from '@ant-design/icons';
import { ActionPill } from './ActionPill';
import { useHomeStrings } from '../../hooks/useHomeStrings';
import { phoneDeeplink, mapDeeplink } from '../../utils/deeplinks';
import type { HomeBusiness, HomeActions } from '../../model/types';

interface Props {
  business: HomeBusiness;
  actions: HomeActions;
}

export const QuickActionsRow: React.FC<Props> = ({ business, actions }) => {
  const STRINGS = useHomeStrings();
  const handleCall = () => {
    if (business.phone) {
      WebApp.openLink(phoneDeeplink(business.phone));
    }
  };

  const handleMap = () => {
    if (business.coordinates) {
      WebApp.openLink(
        mapDeeplink(business.coordinates.lat, business.coordinates.lng, business.name)
      );
    } else if (business.address) {
      WebApp.openLink(
        `https://maps.google.com/maps?q=${encodeURIComponent(business.address)}`
      );
    }
  };

  const hasAny = actions.canCall || actions.canOpenMap;
  if (!hasAny) return null;

  return (
    <div style={{ display: 'flex', gap: 8, margin: '0 16px 12px' }}>
      {actions.canCall && business.phone && (
        <ActionPill
          icon={<PhoneOutlined />}
          label={STRINGS.PHONE_CALL}
          onClick={handleCall}
          ariaLabel={STRINGS.PHONE_CALL}
          iconColor="var(--bl-primary)"
          iconBg="var(--bl-surface)"
        />
      )}
      {actions.canOpenMap && (
        <ActionPill
          icon={<EnvironmentOutlined />}
          label={STRINGS.OPEN_MAP}
          onClick={handleMap}
          ariaLabel={STRINGS.OPEN_MAP}
          iconColor="var(--bl-primary)"
          iconBg="var(--bl-surface)"
        />
      )}
    </div>
  );
};
